import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import config from 'config';
import { useImperativeTimer, ImperativeTimer } from 'hooks/timeout';
import { showIdleMode } from 'actions/idleMode';

const idleTimeout = config.idleMode.idleTimeoutMs;

export const useIdleModeTimer = (): void => {
  const dispatch = useDispatch();
  const timerRef = useRef<ImperativeTimer | null>(null);
  timerRef.current = useImperativeTimer(() => {
    dispatch(showIdleMode());
  }, idleTimeout);

  useEffect(() => {
    timerRef.current?.restart();
  }, []);

  useEffect(() => {
    const onGesture = (): void => {
      timerRef.current?.stop();
      document.removeEventListener('keydown', onGesture, true);
      document.removeEventListener('pointerdown', onGesture, true);
    };
    document.addEventListener('keydown', onGesture, true);
    document.addEventListener('pointerdown', onGesture, true);
    return () => {
      document.removeEventListener('keydown', onGesture, true);
      document.removeEventListener('pointerdown', onGesture, true);
    };
  }, []);
};
